// Os poucos ícones que só o console da Área Resulti usa. Os demais vêm de `desktop/icones.tsx`, que é
// CÓPIA fiel do PlugChef Desktop (ícone novo de lá nasce lá) — por isso estes ficam aqui, com o mesmo
// traço (24×24, currentColor, 2 px).
import type { SVGProps } from 'react';
import type { IconProps } from '../desktop/icones';

function base({ size = 18, ...props }: IconProps): SVGProps<SVGSVGElement> {
  return { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', 'aria-hidden': true, ...props };
}

/** Hoje: o painel (blocos de tamanhos diferentes). */
export const IconHoje = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="7" height="9" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

/** Rede de franquia: a franqueadora ligada às lojas. */
export const IconRede = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="5" r="2.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="5" cy="19" r="2.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="19" cy="19" r="2.5" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7.5v4M12 11.5 6.5 17M12 11.5l5.5 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconMenu = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/** Recolher o menu lateral (duas setas para a esquerda); `Expandir` é o espelho. */
export const IconRecolher = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M11 17l-5-5 5-5M18 17l-5-5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconExpandir = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M13 17l5-5-5-5M6 17l5-5-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Alerta: algo deu errado (erro de cobrança, falha). */
export const IconAlerta = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M12 9v4M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/** Atalho de teclado / comando (a paleta Ctrl K). */
export const IconComando = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M9 6a3 3 0 1 0-3 3h3V6Zm0 0v12m0-12h6m-6 12a3 3 0 1 1-3-3h3v3Zm0 0h6m0 0a3 3 0 1 0 3-3h-3v3Zm0 0V6m0 0a3 3 0 1 1 3 3h-3V6Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
